import * as React from 'react';
import { Grid2 as Grid, Card, CardContent } from '@mui/material';
import { ActionRequest } from '../../actions';
import { Loading, LineChart } from '../common';
import { truncateNumber } from '../../utils';
import { AxisValueFormatterContext } from '@mui/x-charts/models/axis';

interface Props {
    readonly styled: StyledProps;
}

interface State {
    readonly loading: boolean;
    readonly data?: AnalyticsModels.Last30MinutesClientRequestReport;
}

export class Last30MinutesClientRequestReport extends React.PureComponent<Props, State> {
    state: State = {
        loading: true,
    };

    async componentDidMount() {
        await this.getData();
    }

    render() {
        const { styled } = this.props;
        const { loading, data } = this.state;
        if (loading) {
            return (
                <Card style={{ padding: 24 }}>
                    <div style={{ height: 362 }}>
                        <Loading styled={styled} />
                    </div>
                </Card>
            );
        }

        return (
            <Card style={{ padding: 10 }}>
                <CardContent>
                    {!data && (
                        <div style={{ textAlign: 'center' }}>
                            No data available. Please try again later.
                        </div>
                    )}
                    {data && (
                        <Grid container={true} justifyContent="center" spacing={1}>
                            <Grid size={12}>
                                <div style={{ color: styled.themeMode === 'light' ? '#5f6368' : '#8a8e93', letterSpacing: '.5px', fontSize: 14, fontWeight: 500, textUnderlinePosition: 'under', textUnderlineOffset: 1, textDecorationLine: 'underline', textDecorationStyle: 'dashed' }}>
                                    AVERAGE CLIENT REQUEST PER MINUTE
                                </div>
                            </Grid>
                            <Grid size={12}>
                                <div style={{ fontWeight: 400, fontSize: 36 }}>
                                    {data.requestPerMinute.toLocaleString(undefined, {
                                        maximumFractionDigits: 0,
                                    })}
                                </div>
                            </Grid>
                            <Grid size={12}>
                                <div style={{ color: styled.themeMode === 'light' ? '#5f6368' : '#8a8e93', letterSpacing: '.5px', fontSize: 14, fontWeight: 500, textUnderlinePosition: 'under', textUnderlineOffset: 1, textDecorationLine: 'underline', textDecorationStyle: 'dashed' }}>
                                    CLIENT REQUEST PER MINUTE
                                </div>
                                <LineChart
                                    styled={styled}
                                    height={300}
                                    series={[{
                                        data: data.requestByMinutes.map(d => d.requests),
                                        color: '#1973e8',
                                    }]}
                                    xAxis={[{
                                        scaleType: 'point',
                                        data: data.requestByMinutes.map(d => `-${d.minutesAgo} min`),
                                    }]}
                                    yAxis={[
                                        {
                                            valueFormatter: (value: number, context: AxisValueFormatterContext) => `${truncateNumber(value)}`
                                        }
                                    ]}
                                    grid={{ horizontal: true }}
                                    sx={{
                                        '& .MuiChartsAxis-tickLabel': {
                                            fill: styled.themeMode === 'light' ? '#7d8085' : '#a7aaae !important',
                                        },
                                        '& .MuiChartsAxis-tick': {
                                            display: 'none',
                                        },
                                        '& .MuiChartsAxis-line': {
                                            display: 'none',
                                        },
                                        '& .MuiChartsGrid-line': {
                                            stroke: styled.themeMode === 'light' ? '#eeeeee' : '#303030 !important',
                                        }
                                    }}
                                />
                            </Grid>
                        </Grid>
                    )}
                </CardContent>
            </Card>
        );
    }

    private async getData(): Promise<void> {
        this.setState({
            loading: true,
            data: undefined,
        });
        const url = `analytics/last30MinutesClientRequestReport`;
        const data = await ActionRequest.get(url);
        this.setState({
            loading: false,
            data: data || undefined,
        });
    }
}